<template>
    <div id="contenedor-contratistas-main">
      <v-navigation-drawer v-model="mostrar" app dark color="primary">
        <v-list dark dense nav>
          <v-list-item>
            <v-row
              no-gutters
              justify="center"
              align="center">
              <v-img
                src="@/assets/sideop-png.png"
                height="60"
                max-width="150"
                contain>
              </v-img>
            </v-row>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item-group class="mt-2">
            <v-list-item :to="{ name: 'contratitasContratos' }">
              <v-list-item-icon>
                <v-icon>mdi-file-sign</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Contratos</v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-navigation-drawer>
      <MainAppBar class="d-print-none"></MainAppBar>
      <v-main class="main-contenido">
        <router-view/>
      </v-main>
    </div>
</template>

<script>
import MainAppBar from '@/components/MainAppBar.vue';

export default {
  name: 'ContratistasMain',
  components: {
    MainAppBar,
  },
  data() {
    return {
      mostrar: true,
    };
  },
};
</script>

<style lang="scss" scoped>
.main-contenido {
  background-color: #F2F6FF;
}

@media print {
  .main-contenido {
    background-color: #fff !important;
  }
}
</style>
